
export function isElementInRect(el: Element, rect: RectLike) {
  let elementRect = el.getBoundingClientRect();

  return (
    rect.top >= elementRect.top &&
    rect.left >= elementRect.left &&
    rect.bottom <= elementRect.bottom &&
    rect.right <= elementRect.right
  );
}

export function isElementInViewport(el: Element) {
  // https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport
  return isElementInRect(el, {
    top: 0,
    left: 0,
    bottom: window.innerHeight || document.documentElement.clientHeight,
    right: window.innerWidth || document.documentElement.clientWidth
  });
}

export type RectLike = {
  bottom: number;
  left: number;
  right: number;
  top: number;
};
